import { render } from "./MenuGroupItem.vue?vue&type=template&id=8dca6c7a"
import script from "./MenuGroupItem.vue?vue&type=script&lang=js"
export * from "./MenuGroupItem.vue?vue&type=script&lang=js"

import "./MenuGroupItem.vue?vue&type=style&index=0&id=8dca6c7a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__